export default function AccessDeniedPage() {
  return (
    <div className="max-w-2xl mx-auto" style={{ paddingTop: '80px' }}>
      <div className="kicker-rule mb-1">
        <span className="kicker">Admin</span>
      </div>
      <h2 style={{ fontFamily: "'Playfair Display', serif", margin: '0 0 12px' }}>
        Access Denied
      </h2>
      <p style={{ color: 'var(--color-text-muted)', fontSize: '14px' }}>
        Your account does not have admin privileges. Contact the site owner to
        request access.
      </p>
    </div>
  );
}
